'use client';

import { createContext, useContext } from 'react';

interface ContactDialogContextType {
  openContactDialog: () => void;
}

const ContactDialogContext = createContext<ContactDialogContextType | undefined>(undefined);

export function useContactDialog() {
  const context = useContext(ContactDialogContext);
  if (!context) {
    throw new Error('useContactDialog must be used within ContactDialogProvider');
  }
  return context;
}

export { ContactDialogContext };
